import { FormSpy } from 'react-final-form'
import styled from 'styled-components'
import React from 'react'
import Icon from '@material-ui/core/Icon';

const Submitting = styled.div`
  position: absolute;
  background: #fff;
  opacity: 0.8;
  font-size: 20px;
  padding-bottom: 50px;
  color: #444;
  top: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  z-index: 999;
`

class AutoSave extends React.Component {
  constructor(props) {
    super(props)
    this.state = { values: props.values, submitting: false }
  }

  componentWillReceiveProps(nextProps) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(this.save, this.props.debounce)
  }

  save = async () => {
    if (this.promise) {
      await this.promise
    }
    const { values, save, valid, pristine } = this.props
    if (values !== this.state.values) {
      const newValues = {
        ...values
      }
      this.setState({ submitting: true, values })
      this.promise = save(newValues, valid, pristine)
      await this.promise
      delete this.promise
      this.setState({ submitting: false })
    }
  }

  render() {
    return (
      this.state.submitting && <Submitting>Trwa aktualizacja...</Submitting>
    )
  }
}

export default props => (
  <FormSpy {...props} subscription={{ values: true, valid: true, pristine: true }} component={AutoSave} />
)